<template>
    <div class="agreement-container">
        <div class="agreement">
            <h2>受験に関する規約</h2>
            <ul>
                <li>
                    <p>
                        次の事項に該当する行為を行った場合には、これを不正とみなし、受験の資格を与えません。また、受験後に不正が発覚した場合には、これを無効とします。
                    </p>
                    <p>①受験申込時 及び 実務経験申告時に登録した内容に、虚偽の申告があった場合</p>
                    <p>②受験会場において、替え玉受験などの不正行為が行われた場合</p>
                    <p>③試験問題を他者に口外および公表したことが発覚した場合</p>
                    <p>④転売サイトでの公式テキストの転売行為が発覚した場合</p>
                </li>
                <li>
                    <p>体調不良や急用など受験者様都合による受験欠席に関しては、受験料返還は一切行いませんのでご了承ください。</p>
                </li>
                <li>
                    <p>自然災害（大型台風・地震・大雨）などで受験会場が閉鎖された場合には、日を改めて振替受験が可能です。該当者にはご案内をいたします。</p>
                    <p>振替受験を希望されない場合は欠席扱いとなり、受験料の返還は行いませんのでご了承ください。</p>
                </li>
                <li><p>第1希望の会場が予約できなかった場合、希望エリアを広げて会場をご選択いただく必要があります。</p></li>
                <li>
                    <p>住所間違いや不在により、受験書類一式が当協会に返却された場合、再発送手数料を頂戴いたしますのでご注意ください。</p>
                </li>
                <li>
                    <p>受験申し込み後のキャンセルは一切お受けいたしません。</p>
                </li>
                <li>
                    <p>受験資格該当審査にて通過しなかった場合（例：実務経験年数が不足している）は、受験料から審査手数料および事務手数料を差し引いた金額を返金いたします。</p>
                </li>
                <li>
                    <p>合格後は、資格更新システム(月額550円)にて、継続学習をし単位を取得する必要があります。</p>
                </li>
            </ul>
        </div>
        <div class="agreement-group">
            <div class="check">
                <FormInput :checked="value"
                           type="checkbox" name="agreement" id="agreement"
                           :true-value="1" :false-value="0"
                           @input="s => $emit('input', s)"/>
                <label for="agreement">受験規約を読んで同意しました</label>
            </div>
            <ErrorText name="agreement" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";

export default {
    name: "Agreement",
    components: {ErrorText, FormInput},

    props: {
        value: {
            type: Boolean | Number,
        },
        errors: {
            type: Object | Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
